// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"ee4b1ccf","787":"889c69db"}[chunkId] + ".chunk.js";
};